import classNames from 'classnames';
import React from 'react';
import { BlockSkeleton } from '@udemy/react-reveal-components';
import { range } from '@udemy/shared-utils';
import styles from "./partners-banner-skeleton.module.css";
export function PartnersLogosSkeleton({
  numLogos
}) {
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames('ud-unstyled-list', styles.list)
  }, range(numLogos).map((_, i) => {
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: styles.item
    }, /*#__PURE__*/React.createElement(BlockSkeleton, {
      className: styles['item-block']
    }));
  }));
}
export const PartnersBannerSkeleton = ({
  numLogos
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.content,
    "data-testid": "partners-banner-skeleton"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['heading']
  }, /*#__PURE__*/React.createElement(BlockSkeleton, {
    className: styles['heading-block']
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['heading-mobile']
  }, /*#__PURE__*/React.createElement(BlockSkeleton, {
    className: styles['heading-block-mobile']
  }), /*#__PURE__*/React.createElement(BlockSkeleton, {
    className: styles['heading-block-mobile']
  })), /*#__PURE__*/React.createElement(PartnersLogosSkeleton, {
    numLogos: numLogos
  }));
};
//# sourceMappingURL=partners-banner-skeleton.react-component.js.map